import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { ICourtSessionPanel, ICourtUnitType, IJudge, ISessionData } from "../models/case-assignment.model";
import { StaffCourtAssignment } from "@app/lib/models/staff-court-assignment.model";
import { CustomTtRoleDtlsDTO } from "../models/court-staff-roles.model";
import { IJudgeLov } from "../models/reports.model";

@Injectable({
    providedIn: 'root'
})
export class StaffCourtAssignmentService extends BaseHttpService {
  
  
 
    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }

     getDivisions() {
      return this.get<IResponse<ICourtUnitType[]>>('court-unit-types/fetch.htm');
    }

    getCourts(courtUnitTypeId:number) {
        const queryParams={'courtUnitTypeId':courtUnitTypeId}
        return this.get<IResponse<ICourtUnitType[]>>('court-panel/division/courts.htm',{params:queryParams});
    }

    getRoles(divisionId: any) {
        const queryParams={'divisionId':divisionId}
        return this.get<IResponse<CustomTtRoleDtlsDTO[]>>('ttRole-dtls/fetch/roles-lov.htm',{params:queryParams});
    }

    getRoleStaff(queryParams: any) {
        return this.post<IResponse<IJudgeLov[]>,any>('court-staff-assignment/fetch/roles-staff-lov.htm',queryParams);
  }
  checkStatus(reqBody: any) {
     return this.post<IResponse<any>, any>('court-staff-assignment/check/staff-exists.htm', reqBody);
  }

    saveData(reqBody: any) {
     return this.post<IResponse<any>, any>('court-staff-assignment/upsert.htm', reqBody);
  }

  searchStaffData(reqBody: any) {
    return this.post<IResponse<StaffCourtAssignment[]>, any>('court-staff-assignment/search.htm', reqBody);
  }

}